import { Close, FilterList } from "@mui/icons-material";
import {
  Badge,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
} from "@mui/material";
import { useState } from "react";

interface FilterModalProps {
  children: React.ReactNode;
  activeCount?: number;
  // Trava o Aplicar enquanto os campos estão inválidos; quem usa mostra o motivo no próprio campo.
  applyDisabled?: boolean;
  onApply: () => void;
  onClear: () => void;
}

export function FilterModal({ children, activeCount = 0, applyDisabled = false, onApply, onClear }: FilterModalProps) {
  const [open, setOpen] = useState(false);

  const handleApply = () => {
    onApply();
    setOpen(false);
  };

  const handleClear = () => {
    onClear();
    setOpen(false);
  };

  return (
    <>
      <Badge badgeContent={activeCount} color="primary" sx={{ mb: 2 }}>
        <Button
          variant="outlined"
          startIcon={<FilterList />}
          onClick={() => setOpen(true)}
          sx={{ borderRadius: 2.5 }}
        >
          Filtros
        </Button>
      </Badge>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="xs"
        fullWidth
        slotProps={{
          // maxWidth="xs" do MUI é 444px — 30% maior fica em ~577px.
          paper: { sx: { borderRadius: 3, m: 2, maxWidth: 577 } },
        }}
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", pb: 1 }}>
          Filtros
          <IconButton size="small" onClick={() => setOpen(false)}>
            <Close fontSize="small" />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ pt: 2 }}>
          <Stack spacing={2}>
            {children}
          </Stack>
        </DialogContent>

        <DialogActions sx={{ px: 2.5, py: 2, gap: 1 }}>
          <Button variant="outlined" fullWidth onClick={handleClear}>
            Limpar
          </Button>
          <Button variant="contained" fullWidth disabled={applyDisabled} onClick={handleApply}>
            Aplicar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
